import { situacoes } from '@/core/constants'
import tipos from '@/core/constants/tipos'

export default {
	data() {
		return {
			situacoes: situacoes,
			situacaoOndeItemNaoPodeSerAlterado: [situacoes.PEDIDO.EFETIVADO.value, situacoes.PEDIDO.CONCLUIDO.value],
		}
	},
	methods: {
		estaEmRascunho(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === situacoes.PEDIDO.RASCUNHO.value
				}
				return value.situacao === situacoes.PEDIDO.RASCUNHO.value
			}
			return false
		},
		estaEmElaboracao(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === situacoes.PEDIDO.EM_ELABORACAO.value
				}
				return value.situacao === situacoes.PEDIDO.EM_ELABORACAO.value
			}
			return false
		},
		estaConcluido(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === situacoes.PEDIDO.CONCLUIDO.value
				}
				return value.situacao === situacoes.PEDIDO.CONCLUIDO.value
			}
			return false
		},
		naoTemAutorizacaoRealizada(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === tipos.AUTORIZACAO_PEDIDO.NAO_DEFINIDO.value
				}
				return value.autorizado === tipos.AUTORIZACAO_PEDIDO.NAO_DEFINIDO.value
			}
			return false
		},
		itemEstaEfetivado(item) {
			return item.isSaldoAbatido || item.saldoAbatido
		},
		estaEmModoEdicao() {
			return this.isEditar
		},
		estaEmSituacaoOndeItemNaoPodeSerAlterado(value) {
			if (value) {
				if (typeof value === 'string') {
					return this.situacaoOndeItemNaoPodeSerAlterado.indexOf(value) !== -1
				}
				return this.situacaoOndeItemNaoPodeSerAlterado.indexOf(value.situacao) !== -1
			}
			return false
		},
	},
}
